import {FC} from 'react';

import {Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {useAppSelector} from 'hooks';
import {useBasketCalculations} from 'hooks/useBasketCalculations';
import {formatPriceWithCurrency} from 'utils';

import {StyledBasketInfoBanner, StyledBasketSuccessBanner} from '../styled';

export interface BasketFreeDeliveryBannerProps {
  shippingFee?: number;
  noItemSelected: boolean;
  is3P?: boolean;
}

export const BasketFreeDeliveryBanner: FC<BasketFreeDeliveryBannerProps> = (props) => {
  const {t} = useTranslation();
  const {basket} = useAppSelector((state) => state?.basket);
  const {freeThreshold} = useBasketCalculations();

  const i18nKeysSuffix = 'V2';
  let message: string | undefined;

  if (!basket || !basket?.prices || !basket?.shippingRule) {
    return null;
  }

  const hasMinimumBasketAmount = basket.prices.minimumBasket - basket.prices.totalDisplayPricePostVoucher <= 0;
  const basketTotal =
    basket.prices.totalDisplayPricePostVoucher -
    (basket.prices.totalAlcoholPrice || 0) -
    (basket.prices.totalLegalRestrictedPrice || 0);

  const freeDeliverySpend = freeThreshold - basketTotal;
  const isCongratsBanner = props.shippingFee === 0;

  if (
    !hasMinimumBasketAmount ||
    props?.noItemSelected ||
    !basketTotal ||
    ((!!basket.prices.totalAlcoholPrice || !!basket.prices.totalLegalRestrictedPrice) && !isCongratsBanner)
  ) {
    return null;
  }
  if (freeDeliverySpend > 0) {
    message = t(`message.getFreeDeliveryV3`, {
      freeDeliverySpend: formatPriceWithCurrency(freeDeliverySpend, basket.priceUnit),
      deliveryFee: formatPriceWithCurrency(props.shippingFee || basket.prices.shippingFee, basket.priceUnit)
    });
  }
  if (isCongratsBanner) {
    message = t(`message.gotFreeDelivery${i18nKeysSuffix}`);
  }

  if (!message) {
    return null;
  }

  if (!isCongratsBanner && !props.is3P) {
    return (
      <StyledBasketInfoBanner>
        <Typography component={'p'} variant="body2" dangerouslySetInnerHTML={{__html: message}} />
      </StyledBasketInfoBanner>
    );
  }

  return (
    <StyledBasketSuccessBanner>
      <Typography component={'p'} variant="body2" dangerouslySetInnerHTML={{__html: message}} />
    </StyledBasketSuccessBanner>
  );
};

BasketFreeDeliveryBanner.displayName = `BasketFreeDeliveryBanner`;
